<template>
  <div class="event-dialog">
    <v-dialog
      v-model="dialog"
      fullscreen
      transition="dialog-bottom-transition"
      :overlay="false"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon @click.native="dialog = false" dark>
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <v-toolbar-title>Evento</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click.native="dialog = false">cerrar</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <div v-if="loading" class="loading mt-5">
          <v-layout row justify-center>
            <v-progress-circular indeterminate :size="100" color="primary"/>
          </v-layout>
        </div>
        <div v-else class="event">
          <v-container fluid>
            <v-layout v-if="event" class="header" row justify-center>
              <v-flex xs12 sm6 lg4 xl3>
                <v-card class="ma-3">
                  <v-card-title primary-title>
                    <div class="headline">Detalles del Evento</div>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row justify-center>
                      <div class="mb-3" v-if="event">
                        <div class="title text-xs-center">{{ event.vehiclePlate }}</div>
                        <div class="title text-xs-center">{{ event.name }}</div>
                        <div class="title text-xs-center green--text">{{ event.date }}</div>
                        <div
                          class="title text-xs-center green--text"
                          v-if="event.engineState"
                        >Motor encendido</div>
                        <div
                          class="title text-xs-center red--text"
                          v-else
                        >Motor apagado</div>
                      </div>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
            <v-layout v-if="event" class="event-details" row wrap>
              <v-flex v-if="event && event.gps" class="speed-card" xs12 sm6 lg4 xl3>
                <v-card class="ma-3">
                  <v-card-title primary-title>
                    <div class="headline">Velocidad</div>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row justify-center>
                      <div class="mb-3" v-if="event">
                        <speed-gauge :value="event.gps.speed"></speed-gauge>
                      </div>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex v-if="event && event.gps" class="azimuth-card" xs12 sm6 lg4 xl3>
                <v-card class="ma-3">
                  <v-card-title primary-title>
                    <div class="headline">Acimut</div>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row justify-center>
                      <div class="mb-3">
                        <compass-gauge :value="event.gps.azimuth"></compass-gauge>
                      </div>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex v-if="event && event.gps" class="gps-card" xs12 sm6 lg4 xl3>
                <v-card class="ma-3">
                  <v-card-title primary-title>
                    <div class="headline">GPS</div>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row justify-center>
                      <div class="mb-3">
                        <v-container fluid>
                          <div class="title text-xs-center mb-4">
                            {{ event.reverseGeocoding }}
                          </div>
                          <div class="title">
                            Satélites a la vista:
                            <span v-if="event.gps.satellites" class="green--text">
                              {{ event.gps.satellites }}
                            </span>
                            <span v-else class="red--text">NO APLICA</span>
                          </div>
                          <div class="title">
                            Dispersión de la precisión horizontal:
                            <span v-if="event.gps.hdop" class="green--text">
                              {{ event.gps.hdop }}
                            </span>
                            <span v-else class="red--text">NO APLICA</span>
                          </div>
                          <div class="title">
                            Dispersión de la precisión vertical:
                            <span v-if="event.gps.vdop" class="green--text">
                              {{ event.gps.vdop }}
                            </span>
                            <span v-else class="red--text">NO APLICA</span>
                          </div>
                          <div class="title">
                            Latitud:
                            <span class="green--text">
                              {{ event.gps.latitude }}
                            </span>
                          </div>
                          <div class="title">
                            Longitud:
                            <span class="green--text">
                              {{ event.gps.longitude }}
                            </span>
                          </div>
                          <div class="title">
                            Altitud:
                            <span v-if="event.gps.altitude" class="green--text">
                              {{ event.gps.altitude }} msnm
                            </span>
                            <span v-else class="red--text">NO APLICA</span>
                          </div>
                        </v-container>
                      </div>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex v-if="event && event.gsm && event.gsm.signal <= 5" class="gsm-card" xs12 sm6 lg4 xl3>
                <v-card class="ma-3">
                  <v-card-title primary-title>
                    <div class="headline">GSM</div>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row justify-center>
                      <div class="mb-3">
                        <v-layout row justify-center>
                          <signal-gauge :level="event.gsm.signal" class="mb-4"></signal-gauge>
                        </v-layout>
                        <v-container fluid>
                          <div v-if="event.gsm.registration">
                            <div v-if="event.gsm.registration.status" class="title green--text">{{ event.gsm.registration.message }}</div>
                            <div v-else class="title green--text">{{ event.gsm.registration.message }}</div>
                            <div class="title">
                              Código del país:
                              <span class="green--text">
                                {{ event.gsm.codeCountry }}
                              </span>
                            </div>
                            <div class="title">
                              Código de la green:
                              <span class="green--text">
                                {{ event.gsm.codeNetwork }}
                              </span>
                            </div>
                            <div class="title">
                              Código de la estación base:
                              <span class="green--text">
                                {{ event.gsm.baseStationCode }}
                              </span>
                            </div>
                            <div class="title">
                              Identificador de la estación base:
                              <span class="green--text">
                                {{ event.gsm.baseStationIdentifier }}
                              </span>
                            </div>
                            <div class="title">
                              Fuerza de la señal:
                              <span class="green--text">
                                {{ event.gsm.strengthSignal }} dBm
                              </span>
                            </div>
                          </div>
                        </v-container>
                      </div>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex v-if="event && event.batteryLevel" class="battery-card" xs12 sm6 lg4 xl3>
                <v-card class="ma-3">
                  <v-card-title primary-title>
                    <div class="headline">Batería</div>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row justify-center>
                      <div class="mb-3">
                        <voltage-gauge
                          :value="event.batteryLevel"
                          title="Batería"
                        ></voltage-gauge>
                      </div>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex v-if="event && event.backupBatteryLevel" xs12 sm6 lg4 xl3>
                <v-card class="ma-3">
                  <v-card-title primary-title>
                    <div class="headline">Batería de Respaldo</div>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row justify-center>
                      <div class="mb-3">
                        <voltage-gauge
                          :value="event.backupBatteryLevel"
                          title="Respaldo"
                        ></voltage-gauge>
                      </div>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import compassGauge from '@/components/Gauges/Compass'
import speedGauge from '@/components/Gauges/Speed'
import signalGauge from '@/components/Gauges/Signal'
import voltageGauge from '@/components/Gauges/Voltage'

export default {
  name: 'event-dialog',
  data: function () {
    return {
      dialog: false,
      loading: false,
      now: new Date()
    }
  },
  computed: {
    event: function () {
      return this.$store.getters['EventDialog/event'](this.now)
    }
  },
  mounted: function () {
    setInterval(() => {
      this.now = new Date()
    }, 60000)
  },
  components: {
    'compass-gauge': compassGauge,
    'speed-gauge': speedGauge,
    'signal-gauge': signalGauge,
    'voltage-gauge': voltageGauge
  },
  methods: {
    open: async function ({ eventId }) {
      this.loading = true
      this.dialog = true
      await this.$store.dispatch('EventDialog/fetchEvent', { eventId })
      this.loading = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EventDialog.vue